// Regra única de completude de um anúncio de relógio. É a mesma nos dois portões do catálogo:
// o envio para aprovação pelo anunciante (editDraftModal.tsx) e a publicação pelo admin (watchModal.tsx).

export const WATCH_INFOS_TOTAL = 13;
export const WATCH_INFOS_MIN = 11;
export const WATCH_IMAGES_MIN = 1;

// quantas das 13 informações da aba "Informações" estão preenchidas
export function countWatchInfos(watch: { [key: string]: any } | null | undefined) {
    if (!watch) {
        return 0;
    }
    const filled = [
        watch.serial,
        watch.state,
        // functions é um array: [] é truthy, mas não conta como preenchido
        Array.isArray(watch.functions) ? watch.functions.length : watch.functions,
        watch.movement,
        watch.movementModel,
        watch.braceletMaterial,
        watch.caseMaterial,
        watch.diameter,
        watch.tightness,
        watch.glass,
        watch.content,
        watch.price,
        watch.boxAndDocuments || watch.boxAndDocuments === false,
    ];
    return filled.filter(Boolean).length;
}

// o que ainda falta para o anúncio poder ir ao catálogo — lista vazia = pronto
export function getWatchPendencies(watch: { [key: string]: any } | null | undefined) {
    const pendencies: string[] = [];
    const infos = countWatchInfos(watch);
    if (infos < WATCH_INFOS_MIN) {
        pendencies.push(`preencher ao menos ${WATCH_INFOS_MIN} das ${WATCH_INFOS_TOTAL} informações (hoje: ${infos})`);
    }
    if ((watch?.images?.length || 0) < WATCH_IMAGES_MIN) {
        pendencies.push(WATCH_IMAGES_MIN === 1 ? "enviar ao menos 1 imagem" : `enviar ao menos ${WATCH_IMAGES_MIN} imagens`);
    }
    if (!watch?.original) {
        pendencies.push("declarar a responsabilidade pela autenticidade do produto");
    }
    return pendencies;
}
